import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RCrmFieldDirty = t.readonly(
  t.type({
    id: t.string,
    label: t.string,
    type: t.string,
  }),
);

/*
 * Type.
 */

export interface CrmFieldModel extends t.TypeOf<typeof RCrmFieldDirty> {}
export const RCrmField = t.clean<CrmFieldModel>(RCrmFieldDirty as any);
export const RCrmFields = t.readonlyArray(RCrmField);

/*
 * IO methods.
 */

export function parseCrmField(src: any) {
  return {
    id: src.name,
    label: src.label,
    type: src.type,
  };
}

export function parseCrmFields(src: any): ReadonlyArray<CrmFieldModel> {
  return src.map(parseCrmField);
}

/*
 * API type.
 */

export const ApiCrmField = makeApiType('crmField', RCrmField, parseCrmField);
export const ApiCrmFields = makeApiType('crmFields', RCrmFields, parseCrmFields);
